import { HStack, Stack, StackProps } from '@chakra-ui/react';
import type { Ref } from 'react';

export function FooterSettingsSection({
   ref,
   ...props
}: StackProps & { ref?: Ref<HTMLDivElement> }) {
   return (
      <Stack
         ref={ref}
         py={{
            base: 6,
            xl: 5,
         }}
         direction={{
            base: 'column',
            md: 'row',
         }}
         spacing={{
            base: 10,
            xl: 0,
         }}
         justify="space-between"
         align="center"
         {...props}
      />
   );
}

export function FooterSettings({ ref, ...props }: StackProps & { ref?: Ref<HTMLDivElement> }) {
   return (
      <HStack
         ref={ref}
         spacing={{
            base: 6,
            sm: 12,
         }}
         {...props}
      />
   );
}
